Apt.fn.make('properties.sync', {
	/**
	 * Initialize property syncing module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;
		const priv = scope.$private;

		let map;

		priv.conf = Object.assign({
			controls: true,
			minZoom: 7,
			push: true
		}, options);

		priv.states = {
			sync: 'Search here',
			enable: 'Search as map moves',
			disable: 'Disable map search'
		};

		map = priv.conf.map;

		map.ready(() => {
			const filters = LS.filters.get();

			priv.bounds = filters.bounds ?
				map.getBounds() : null;
			priv.center = filters.center ?
				map.getCenter(true) : null;
			priv.syncable = map.getZoom() >= priv.conf.minZoom;

			if (priv.syncable) {
				$$('syncSearch').show();
			}

			if (scope.check() && priv.syncable) {
				scope.enable();
			} else {
				priv.toggle();
			}

			priv.bindScreen();

			map.debounce('move', () => {
				priv.sync();
			});
		});

		return scope;
	},

	/**
	 * Determine if syncing is enabled
	 *
	 * @param {Boolean} [active=false] - ensure syncing is currently active
	 * @returns {Boolean}
	 */
	check(active) {
		if ($.screen.size() < 6) {
			return false;
		}

		return (active ? this.$private.syncable : true) &&
			LS.filters.get('sync') === '1';
	},

	/**
	 * Enable map syncing
	 */
	enable() {
		const priv = this.$private;

		if (priv.active) {
			return;
		}

		priv.active = true;

		priv.toggle(true);

		$$('syncSearch').text(priv.states.disable);
	},

	/**
	 * Disable map syncing
	 *
	 * @param {Boolean} [reset=true]
	 */
	disable(reset) {
		const priv = this.$private;

		priv.active = false;

		if (! priv.conf.map) {
			return;
		}

		priv.reset(reset !== false);
	},

	/**
	 * Pause map syncing
	 */
	pause() {
		this.$private.paused = true;
	},

	/**
	 * Resume map syncing
	 */
	resume() {
		this.$private.paused = false;
	},

	/**
	 * Get the current sync bounds
	 *
	 * @returns {*}
	 */
	getBounds() {
		return this.$private.bounds;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		this.pause();

		LS.util.reset('sync');
	}
}, {
	/**
	 * Bind sync screen mapping
	 */
	bindScreen() {
		const scope = this;
		const pub = scope.$public;

		$.screen.map([
			{
				max: 3,
				init: false,
				callback: () => {
					if (! scope.active) {
						return;
					}

					scope.reset(true);

					pub.pause();
				}
			},
			{
				min: 4,
				callback: () => {
					scope.bindButton();

					if (! scope.active) {
						return;
					}

					pub.resume();
				}
			}
		], {
			namespace: 'sync'
		});
	},

	/**
	 * Bind button events
	 */
	bindButton() {
		const scope = this;
		const $sync = $$('syncSearch');
		const states = scope.states;

		$sync.on('mousedown', () => {
			if (scope.active) {
				$sync.text(states.sync);

				scope.$public.disable();

				return;
			}

			if ($sync.text() === states.enable) {
				LS.analytics.interact('properties', 'sync');

				$sync.text(states.disable);

				scope.$public.enable();

				return;
			}

			LS.analytics.interact('properties', 'here');

			$sync.text(states.enable);

			scope.refresh();
		}, {
			namespace: 'sync'
		});
	},

	/**
	 * Toggle sync button state
	 *
	 * @param {Boolean} [check=false]
	 */
	toggle(check) {
		const scope = this;
		const fn = () => {
			if (! scope.active) {
				$$('syncSearch').text(scope.states.sync);
			}
		};

		if (! scope.conf.map) {
			fn();

			return;
		}

		if ((scope.conf.map.getZoom() >= scope.conf.minZoom) && ! Apt.panel.opened()) {
			scope.conf.map.resumePosition();

			fn();

			return;
		}

		if (check === true) {
			scope.conf.map.pausePosition();

			return;
		}

		fn();
	},

	/**
	 * Sync visible map listings
	 */
	sync() {
		const scope = this;
		const zoom = scope.conf.map.getZoom();

		$$('syncSearch').toggle(zoom >= scope.conf.minZoom);

		if (scope.paused) {
			return;
		}

		if (zoom > scope.conf.minZoom && ! scope.syncable) {
			scope.toggle(scope.active);
		}

		if (zoom < scope.conf.minZoom) {
			let reset = false;

			if (scope.active) {
				reset = scope.syncable;
				scope.syncable = false;

				scope.toggle(true);
			}

			if (reset) {
				scope.reset(true);
			}

			return;
		}

		scope.syncable = true;

		scope.active ?
			scope.refresh(true) :
			scope.reset(false);
	},

	/**
	 * Updated listings based on bounds
	 *
	 * @param {Boolean} [sync]
	 */
	refresh(sync) {
		const scope = this;
		const bounds = scope.conf.map.getBounds();

		let filters;

		if ($.equals(scope.bounds, bounds)) {
			return;
		}

		filters = LS.filters.get();

		scope.bounds = bounds;

		if (sync) {
			scope.bounds = bounds;

			if (scope.conf.push) {
				filters.sync = 1;
			}
		} else {
			delete filters.sync;
		}

		if (scope.conf.push) {
			filters.bounds = scope.bounds;
		}

		filters.page = 1;

		scope.update(filters);
	},

	/**
	 * Update index data
	 *
	 * @param {Object} filters
	 */
	update(filters) {
		const scope = this;
		const conf = scope.conf;

		if (! conf.index || Apt.panel.opened()) {
			return;
		}

		const position = conf.map.getPosition();

		filters.center = position.center;
		filters.zoom = position.zoom;

		delete filters.geometry;
		delete filters.location;

		$.history.replace(
			LS.filters.build(LS.filters.root(), filters)
		);

		conf.index.update(Object.assign({
			event: false,
			scrollTop: 0
		}), filters);
	},

	/**
	 * Reset syncing to default state
	 *
	 * @param {Boolean} [refresh=false]
	 */
	reset(refresh) {
		const scope = this;

		scope.bounds = null;

		scope.toggle();

		if (refresh) {
			const filters = LS.filters.get();

			delete filters.bounds;
			delete filters.sync;

			scope.update(filters);
		}
	}
});